import { FilterFields } from 'shared/mui/Filter/FilterFields/FilterFields';

import { useUserActionsListFilterFields } from './hooks/useUserActionsListFilterFields';

export const UserActionsListFilterForm: React.FC = () => {
  const fields = useUserActionsListFilterFields();

  return <FilterFields fields={fields} />;
};
